// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-stepper {
  padding: 3.5rem 16rem 0rem 16rem;
}
.custom-stepper .MuiStepConnector-line {
  border-top-width: 0px;
  border-color: #e5e7eb;
  border-style: dashed;
}
.custom-stepper .Mui-active .MuiStepConnector-line,
.custom-stepper .Mui-completed .MuiStepConnector-line {
  border-color: #3F78B0;
  border-style: solid;
}
.custom-stepper .MuiStepLabel-label {
  margin-top: 0;
  font-weight: 500;
  color: #9ca3af;
}
.custom-stepper .MuiStepLabel-label.Mui-active, .custom-stepper .MuiStepLabel-label.Mui-completed {
  color: #1F4997;
}
.custom-stepper .custom-step-icon {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 0.8rem;
  transition: all 0.3s ease;
  background-color: #e5e7eb;
  color: #9ca3af;
}
.custom-stepper .custom-step-icon--active {
  background-color: #475F77;
  color: #ffffff;
}
.custom-stepper .custom-step-icon--completed {
  background-color: #3F78B0;
  color: #ffffff;
}
.custom-stepper .custom-step-icon--completed .MuiSvgIcon-root {
  font-size: 1.2rem;
}
@media (max-width: 1260px) {
  .custom-stepper {
    padding: 2.5rem 5rem 0rem 5rem;
  }
}
@media (max-width: 990px) {
  .custom-stepper {
    padding: 2.5rem 0rem 0rem 0rem;
  }
  .custom-stepper .MuiStepLabel-label {
    font-size: 0.8rem;
  }
}
@media (max-width: 1445px) {
  .custom-stepper {
    padding: 2.5rem 8rem 0rem 8rem;
  }
}
@media (max-width: 1198px) {
  .custom-stepper {
    padding: 2.5rem 5rem 0rem 5rem;
  }
}
@media (max-width: 900px) {
  .custom-stepper {
    padding: 0;
  }
  .custom-stepper .MuiStepper-vertical .MuiStepConnector-line {
    border-left-width: 1px;
    min-height: 40px;
  }
  .custom-stepper .MuiStepper-vertical .MuiStep-root {
    padding: 0.5rem 0rem 0.5rem 0rem;
    border-bottom: 1px solid rgba(63, 120, 176, 0.168627451);
  }
  .custom-stepper .MuiStepper-vertical .MuiStepLabel-label {
    text-align: left;
  }
  .custom-stepper .css-1afu6qk-MuiStepConnector-root {
    display: none !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_CustomStepper.scss"],"names":[],"mappings":"AASA;EACE,gCAAA;AARF;AAUE;EACE,qBAAA;EACA,qBAZoB;EAapB,oBAAA;AARJ;AAWE;;EAEE,qBApBqB;EAqBrB,mBAAA;AATJ;AAYE;EACE,aAAA;EACA,gBAAA;EACA,cAvBiB;AAarB;AAYI;EAEE,cAAA;AAXN;AAeE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EAEA,yBA5CoB;EA6CpB,cA3CiB;AA6BrB;AAgBI;EACE,yBAjDgB;EAkDhB,cA9CQ;AAgCd;AAiBI;EACE,yBAvDmB;EAwDnB,cAnDQ;AAoCd;AAiBM;EACE,iBAAA;AAfR;AAoBE;EAvDF;IAwDI,8BAAA;EAjBF;AACF;AAmBE;EA3DF;IA4DI,8BAAA;EAhBF;EAiBG;IACC,iBAAA;EAfJ;AACF;AAkBG;EAlEH;IAmEI,8BAAA;EAfF;AACF;AAiBG;EAtEH;IAuEI,8BAAA;EAdF;AACF;AAgBE;EA1EF;IA2EI,UAAA;EAbF;EAgBI;IACE,sBAAA;IACA,gBAAA;EAdN;EAiBI;IACE,gCAAA;IACA,wDAAA;EAfN;EAkBI;IACE,gBAAA;EAhBN;EAoBE;IACE,wBAAA;EAlBJ;AACF","sourcesContent":["$stepper-blue-completed: #3F78B0;\n$stepper-dark-active: #475F77;\n$stepper-grey-inactive: #e5e7eb;\n$stepper-text-dark: #374151;\n$stepper-text-light: #9ca3af;\n$white-color: #ffffff;\n$breakpoint-xs: 900px; \n$breakpoint-md: 1260px;\n\n.custom-stepper {\n  padding: 3.5rem 16rem 0rem 16rem;\n\n  .MuiStepConnector-line {\n    border-top-width: 0px; \n    border-color: $stepper-grey-inactive;\n    border-style: dashed; \n  }\n\n  .Mui-active .MuiStepConnector-line,\n  .Mui-completed .MuiStepConnector-line {\n    border-color: $stepper-blue-completed;\n    border-style: solid;\n  }\n\n  .MuiStepLabel-label {\n    margin-top: 0;\n    font-weight: 500;\n    color: $stepper-text-light;\n\n    &.Mui-active,\n    &.Mui-completed {\n      color: #1F4997;\n    }\n  }\n\n  .custom-step-icon {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 400;\n    font-size: 0.8rem;\n    transition: all 0.3s ease;\n    \n    background-color: $stepper-grey-inactive;\n    color: $stepper-text-light;\n\n    &--active {\n      background-color: $stepper-dark-active;\n      color: $white-color;\n    }\n    \n    &--completed {\n      background-color: $stepper-blue-completed;\n      color: $white-color;\n\n      .MuiSvgIcon-root {\n        font-size: 1.2rem;\n      }\n    }\n  }\n\n  @media (max-width: $breakpoint-md) { \n    padding: 2.5rem 5rem 0rem 5rem;\n  }\n\n  @media (max-width: 990px) { \n    padding: 2.5rem 0rem 0rem 0rem;\n     .MuiStepLabel-label {\n      font-size: 0.8rem;\n     }\n  }\n\n   @media (max-width: 1445px) { \n    padding: 2.5rem 8rem 0rem 8rem\n  }\n\n   @media (max-width: 1198px) { \n    padding: 2.5rem 5rem 0rem 5rem\n  }\n\n  @media (max-width: $breakpoint-xs) { \n    padding: 0;\n    \n    .MuiStepper-vertical {\n      .MuiStepConnector-line {\n        border-left-width: 1px;\n        min-height: 40px;\n      }\n\n      .MuiStep-root {\n        padding: 0.5rem 0rem 0.5rem 0rem;\n        border-bottom: 1px solid #3f78b02b;\n      }\n\n      .MuiStepLabel-label {\n        text-align: left;\n      }\n    }\n\n    .css-1afu6qk-MuiStepConnector-root{\n      display: none !important;\n    }\n  }\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
